import React from 'react'
import POSComponent from "../components/POSComponent";


export default function POSContainer() {
  return (
    <POSComponent />
  )
}
